import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { useCallback, useState } from 'react';
import { useApiBase } from '../../base/api-base';


export enum EnumStatusIndicacaoRevendedor {
    Pendente,
    Aprovado,
    Rejeitado
}

export const indicacaoQueryList = {
    resultado: {
        data: {
            page: 1,
            totalPages: 10,
            totalResults: 100,
            pageIndex: 1,
            list: [
                {
                    id: 'b1a7e2c3-1f2d-4a5b-8c6e-1234567890ab',
                    dataIndicacao: '2024-06-01',
                    nome: 'Empresa Alpha',
                    cnpj: '12.345.678/0001-90',
                    telefone: '(11) 91234-5678',
                    status: EnumStatusIndicacaoRevendedor.Pendente
                },
                {
                    id: 'c2b8f3d4-2e3f-5b6c-9d7f-2345678901bc',
                    dataIndicacao: '2024-06-02',
                    nome: 'Comercial Beta',
                    cnpj: '98.765.432/0001-10',
                    telefone: '(21) 99876-5432',
                    status: EnumStatusIndicacaoRevendedor.Aprovado
                },
                {
                    id: 'd3c9g4e5-3f4g-6c7d-0e8g-3456789012cd',
                    dataIndicacao: '2024-06-03',
                    nome: 'Distribuidora Gama',
                    cnpj: '23.456.789/0001-01',
                    telefone: '(31) 93456-7890',
                    status: EnumStatusIndicacaoRevendedor.Rejeitado
                },
                {
                    id: 'e4d0h5f6-4g5h-7d8e-1f9h-4567890123de',
                    dataIndicacao: '2024-06-04',
                    nome: 'Serviços Delta',
                    cnpj: '34.567.890/0001-12',
                    telefone: '(41) 94567-8901',
                    status: EnumStatusIndicacaoRevendedor.Pendente
                },
                {
                    id: 'f5e1i6g7-5h6i-8e9f-2g0i-5678901234ef',
                    dataIndicacao: '2024-06-05',
                    nome: 'Tech Epsilon',
                    cnpj: '45.678.901/0001-23',
                    telefone: '(51) 95678-9012',
                    status: EnumStatusIndicacaoRevendedor.Aprovado
                }
            ],
        }
    },
    erro: null
}

export function useGetIndicacaoRevendedores() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<any>>();
    const [carregando, setCarregando] = useState(true);
    const getIndicacaoRevendedores = useCallback(
        (newPage: number, query?: string) => {
            return new Promise<typeof indicacaoQueryList>((resolve) => {
                setCarregando(true)
                const termo = query?.replace('pageSize=18&query=', '') || '';
                setTimeout(() => {
                    resolve({
                        ...indicacaoQueryList,
                        resultado: {
                            data: {
                                ...indicacaoQueryList.resultado.data,
                                list: indicacaoQueryList.resultado.data.list.filter(item => {
                                    if (!termo) return true
                                    return item.nome.toLowerCase().includes(termo.toLowerCase()) ||
                                        item.cnpj.includes(termo) ||
                                        item.telefone.includes(termo)
                                })
                            }
                        }
                    });
                    setCarregando(false);
                }, 2000);
            });
        }

        // invocarApi({
        //     url: `${VariaveisAmbiente.apiVersion}/indicacao-revenda?page=${newPage}&${query}`,
        //     method: 'GET',
        //     enviarTokenUsuario: true
        // }),
        , [],
    );
    return {
        ...outrasPropriedades,
        carregando,
        getIndicacaoRevendedores,
    };
}
